<template>
    <div class="summary-budget-line">
        <div class="image">
            <img src="/img/iconos/custom_default.svg" alt="custom_default.svg">
        </div>
        <div class="right-image">
            <div class="variety-data">
                <div class="especie-name">{{ variety.mote.especie.nombre }}</div>
                <div>
                    <span style="text-transform: uppercase; font-weight: bold">
                        {{ variety.nombre }}
                    </span>
                    (<span style="text-transform: lowercase">{{ variety.mote.nombre }}</span>)
                </div>
                <div class="plant-icons">
                    <img v-if="eco" src="/img/iconos/icon_ecologico.svg" alt="Ecológico">
                    <template v-if="injertada">
                        <img src="/img/iconos/icon_injertada.svg" alt="Injertada">
                    </template>
                </div>
            </div>
            <div style="margin-left: auto;">
                <a v-if="!deleting" class="change-btn trash" @click="remove"><i class="fas fa-trash-alt"></i></a>
                <div v-else class="trash-loading">
                    <b-spinner small variant="success"></b-spinner>
                </div>
                <a v-if="!duplicating" class="change-btn" @click="duplicate">Duplicar</a>
                <div v-else class="change-btn-loading">
                    <b-spinner small variant="success"></b-spinner>
                </div>
                <a class="change-btn" @click="edit">Cambiar</a>
            </div>
            <div>
                <div>
                    <span style="font-weight: bold">Fecha de entrega</span> {{ dateFormatted }}
                </div>
                <div>
                    <div v-for="tray in trays">
                        · {{ tray.num_trays }} bandejas, {{ tray.tray.unidades }} alvéolos,
                        {{ seedsByAlveolus }} semillas alvéolo<br>
                    </div>
                </div>
            </div>
            <div class="total-price">
                {{ formatMoney(totalPrice) }}
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "SummaryBudgetLine",
        props: {
            budgetLine: {
                type: Object
            }
        },
        data() {
            return {
                deleting: false,
                duplicating: false,
            }
        },
        computed: {
            eco() {
                return this.budgetLine.eco_type;
            },
            injertada() {
                return this.budgetLine.injerto_type;
            },
            date() {
                return this.budgetLine.date;
            },
            dateFormatted() {
                return moment(this.date).format('D [de] MMMM [de] YYYY')
            },
            variety() {
                return this.budgetLine.variety;
            },
            trays() {
                return this.budgetLine.trays;
            },
            seedsByAlveolus() {
                return this.budgetLine.seeds_by_alveolus;
            },
            totalPrice() {
                return this.budgetLine.total_price;
            },
            id() {
                return this.budgetLine.id;
            }
        },
        methods: {
            remove() {
                let vm = this;
                let formData = new FormData();
                formData.append('delete_line', 1);
                formData.append('id', vm.id);
                vm.deleting = true;
                axios.post(vm.route('custom.summary-next'), formData).then((response) => {
                    vm.$emit('removed', this.budgetLine);
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.deleting = false;
                });
            },
            duplicate() {
                let vm = this;
                let formData = new FormData();
                formData.append('duplicate_line', 1);
                formData.append('id', vm.id);
                vm.duplicating = true;
                axios.post(vm.route('custom.summary-next'), formData).then((response) => {
                    vm.$emit('duplicated', response.data.budgetLine);
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.duplicating = false;
                });
            },
            edit() {
                this.$emit('edit', this.budgetLine);
            }
        }
    }
</script>

<style scoped>

    .summary-budget-line {
        text-align: left;
        margin: 0.5rem 0;
        padding: 1rem;
        border: 1px solid #cac8c9;
        border-radius: 7px;
        display: flex;
    }

    .summary-budget-line .image {
        display: none;
        width: 7rem;
        min-width: 7rem;
        text-align: center;
        margin-left: -1rem;
        padding: 1rem;
    }

    .summary-budget-line .right-image {
        flex: 1 1 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .summary-budget-line .variety-data {
        flex: 1 1 70%;
    }

    .change-btn {
        display: block;
        border-color: #0871b8;
        text-align: center;
        text-decoration: none;
        font-weight: bold;
        color: #0871b8;
        width: 100%;
        cursor: pointer;
        border-radius: 3px;
        border: 1px solid;
        transition: all 0.15s ease;
        padding: 0.4rem;
        max-width: 250px;
        line-height: 1;
        margin: auto;
        font-size: 0.8em;
        margin-bottom: 3px;
    }

    .change-btn.trash {
        width: fit-content;
        margin-left: auto;
        margin-right: 0;
    }

    .trash-loading {
        width: fit-content;
        margin-left: auto;
        margin-right: 0;
    }

    .change-btn-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.4em;
    }

    .plant-icons img {
        height: 1.5em;
    }

    .especie-name {
        font-weight: bold;
        font-size: 1.2em;
        line-height: 1;
        color: #029790;
    }

    .total-price {
        font-weight: bold;
        font-size: 1.2em;
        line-height: 1;
        color: #029790;
        margin-left: auto; align-self: flex-end; padding-left: 1em
    }

    @media (min-width: 575px) {

        .summary-budget-line .image {
            display: block;
        }

    }

    @media (min-width: 992px) {
        .summary-budget-line {
            margin: 0.5rem 1rem;
        }

    }


</style>
